import Blogs from "../../components/blogs/blogs";
import CustomMetas from "../../components/custom-metas/customMetas";
import { BLOG_POSTS_LIST } from "../../graphql/blogs/queries";
import { GET_STORE_CONFIG } from "../../graphql/store/queries";
import parseSearchParams from "../../helpers/SearchParams";
import { getClient } from "../../Providers/graphqlClient";

const BlogsPage = ({ blogs, storeConfig }) => {


    return (
        <>
            <CustomMetas title={storeConfig.blog_seo_meta_title}
                description={storeConfig.blog_seo_meta_description}
                keywords={storeConfig.blog_seo_meta_keywords}
                noindex
                page_type="catalogs" />
            <Blogs blogs={blogs.items} pageInfo={blogs.pageInfo} />
        </>
    )
}

export default BlogsPage;

export const getStaticPaths = async () => {
    return {
        paths: [],
        fallback: 'blocking'
    }
}

export const getStaticProps = async (context) => {
    const client = getClient(context.locale)

    const { params, locales, locale } = context

    const { page } = parseSearchParams(params)

    const { data: storeData } = await client.query({
        query: GET_STORE_CONFIG,
    })

    console.log((locales.indexOf(locale)).toString());
    

    const { data } = await client.query({
        query: BLOG_POSTS_LIST,
        variables: {
            currentPage: page || 1,
            pageSize: 12,
            store_ids: (locales.indexOf(locale)).toString(),
            category_id: "3",// deprecated by WH
            categoryKey: "blogs"
        }
    })

    return {
        props: {
            blogs: data.blogPostsList,
            storeConfig: storeData.storeConfig
        },
        revalidate: 10
    }
}